import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RolesResponse } from '~/Services/AdminRolesService'

export interface RolesReducerStore {
  listRolesData: RolesResponse[] | null
  loading: boolean
  success: boolean
  error?: string | null
  rolesUserID: string[]
  userRoles: {
    [userId: string]: string[]
  }
}

const initialState: RolesReducerStore = {
  listRolesData: null,
  loading: false,
  success: false,
  error: undefined,
  rolesUserID: [],
  userRoles: {},
}

export const RolesSlice = createSlice({
  name: 'Roles',
  initialState,
  reducers: {
    getRolesRequest: () => {},
    setRolesSuccess: (state, action) => {
      state.listRolesData = action.payload
      //console.log('setRolesSuccess', state.listRolesData)
    },
    setRolesError: state => {
      state.listRolesData = null
    },
    addRolesRequest: (state, action: PayloadAction<string>) => {},

    addRoleSuccess: (state, _action: PayloadAction<any>) => {},
    addRoleError: state => {},
    updateRoleRequest: (
      _state,
      _action: PayloadAction<{ roleName: string; newRolename: string }>,
    ) => {},
    updateRoleSuccess: (state, _action: PayloadAction<any>) => {},
    updateRoleError: state => {},

    deleteRoleRequest: (_state, _action: PayloadAction<string>) => {},
    deleteRoleSuccess: (state, _action: PayloadAction<any>) => {},
    deleteRoleError: state => {},
    updateUserRoles: (state, action) => {
      state.loading = true
    },
    updateUserRoleFailure(state, action: PayloadAction<string>) {
      state.loading = false
      state.success = false
      state.error = action.payload
    },
    getUserRolesRequest: (state, action: PayloadAction<string>) => {
      state.loading = true
      state.error = null
    },
    getUserRolesSuccess: (state, action: PayloadAction<string[]>) => {
      state.loading = false
      state.rolesUserID = action.payload
    },
    getUserRolesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    },
    deleteUserRolesRequest: (
      state,
      action: PayloadAction<{ userId: string; roleName: string[] }>,
    ) => {},
    deleteUserRolesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    },
  },
})

export const RolesActions = RolesSlice.actions
export const RolesReducer = RolesSlice.reducer
